import React, { FC } from "react";
import {
  FileUploader,
  TFileWithPath,
} from "kanopi-components/FileUploader/FileUploader";
import { WidthContainer } from "../ChatFlow";

type TFileUploadDisplay = {
  answer: TFileWithPath;
};
export const FileUploadDisplay: FC<TFileUploadDisplay> = ({ answer }) => {
  return (
    <WidthContainer>
      <FileUploader file={answer} displayMode={true} />
    </WidthContainer>
  );
};
